import React from "react"
import i18n from "i18n"
import { Grid, Box, Typography, IconButton } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import DownloadIcon from "@mui/icons-material/Download"
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"
import PropTypes from "prop-types"

import CircularProgress from "@mui/material/CircularProgress"
const AttachedFilesList = ({
  attachedFiles,
  onRemoveFile,
  onDownloadFile,
  formatFileSize,
}) => {
  if (attachedFiles.length === 0) return null

  return (
    <>
      {attachedFiles.map((file, idx) => {
        const removeTargetId = file.id ?? file.new_filename
        const rowKey = removeTargetId ?? `file-row-${idx}`
        return (
          <Grid item xs={12} md={4} key={rowKey}>
            <Box
              sx={{
                border: "1px solid #eeeeee",
                borderRadius: 1,
                p: 2,
                display: "flex",
                alignItems: "center",
                position: "relative",
                width: "100%",
                overflow: "hidden",
              }}
            >
              <InsertDriveFileIcon
                sx={{ mr: 1, color: "text.secondary", flexShrink: 0 }}
              />
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  overflow: "hidden",
                  minWidth: 0,
                  maxWidth: "calc(100% - 100px)",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flexShrink: 1,
                    minWidth: 0,
                    maxWidth: "70%",
                  }}
                >
                  {file.original_filename || file.name}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ flexShrink: 0 }}
                >
                  {file.size ? formatFileSize(file.size) : ""}
                </Typography>
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  right: 4,
                  top: "50%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  gap: 0.5,
                }}
              >
                {file.isUploading || file.isDownloading ? (
                  <CircularProgress size={22} sx={{ marginRight: 1 }} />
                ) : (
                  <>
                    <IconButton
                      size="small"
                      onClick={() => onDownloadFile(file)}
                      title={i18n.t("costs.modal.downloadFile")}
                      sx={{ flexShrink: 0 }}
                    >
                      <DownloadIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() =>
                        removeTargetId != null && onRemoveFile(removeTargetId)
                      }
                      title={i18n.t("costs.modal.removeFile")}
                      sx={{ flexShrink: 0 }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </>
                )}
              </Box>
            </Box>
          </Grid>
        )
      })}
    </>
  )
}

AttachedFilesList.propTypes = {
  attachedFiles: PropTypes.array.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  formatFileSize: PropTypes.func.isRequired,
}

export default AttachedFilesList
